import React, { Component } from 'react';
import axios from 'axios';

import CaptchaModal from './CaptchaModal';

class UserForm extends Component {
  state = {
    email: '',
    phone: '',
    isOpen: false,
  };

  onEmailChange = (e) => {
    const email = e.target.value;
    this.setState(() => ({
      email,
    }));
  };

  onPhoneChange = (e) => {
    const phone = e.target.value;
    if (!phone || phone.match(/^[+]?[0-9]*$/)) {
      this.setState(() => ({ phone }));
    }
  };

  closeModal = () => {
    this.setState(() => ({ isOpen: false }));
  }

  closeModalAndReset = () => {
    const { resetApp } = this.props;
    this.setState(() => ({ isOpen: false }));
    resetApp();
  }

  openModal = () => {
    this.setState(() => ({ isOpen: true }));
  }

  sendEmail = (recaptcharesponse) => {
    const { result, consultation } = this.props;
    const { email, phone } = this.state;
    const konzultacia = consultation ? 'Ano' : 'Nie';
    let location = window.location.href;
    location = location.replace('build/index.html', 'contact.php');
    try {
      axios.get(location, {
        params: {
          from: email,
          sadzba: result.interest,
          roky: result.creditYears,
          uver: result.vyskaUveru,
          phone,
          recaptcharesponse,
          konzultacia,
        },
      });
    } catch (e) {
      console.log('An error occurred while sending the email:', e);
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.openModal();
  };

  render() {
    const { email, phone, isOpen } = this.state;
    const { checked } = this.props;
    return (
      <div>
        <form className="user-form" onSubmit={this.onSubmit}>
          <div className="user-form__item">
            <label className="form-label" htmlFor="email">E-mail</label>
            <input
              className="form-input form-input--user"
              id="email"
              onChange={this.onEmailChange}
              required
              type="email"
              value={email}
            />
          </div>
          <div className="user-form__item">
            <label className="form-label" htmlFor="phone">Telefón</label>
            <input
              className="form-input form-input--user"
              id="phone"
              onChange={this.onPhoneChange}
              value={phone}
            />
          </div>
          <button type="submit" disabled={!checked} className="btn">Zaslať</button>
        </form>
        <CaptchaModal isOpen={isOpen} closeModalAndReset={this.closeModalAndReset} closeModal={this.closeModal} sendEmail={this.sendEmail} />
      </div>
    );
  }
}

export default UserForm;
